import { Component, ElementRef, ViewChild } from '@angular/core';
import { ModalController} from 'ionic-angular';
import { Config } from 'ionic-angular';

@Component({
  selector: 'rmt-snackbar',
  templateUrl: 'rmt-snackbar.html'
})
export class RmtSnackbarComponent {
  @ViewChild('snackbar', { read: ElementRef }) container;
  static icon = 'custom-icon-checkmark-carbon';
  static status: string;
  static message: string;
  static label: string;
  static duration: number = 5000;
  static config;
  static modalCtrl;
  static snackBarModal;
  static queue: any = [];
  static isSnackBarPresent = false;
  static staticContainer;
  static timeout;

  constructor(
    private config: Config,
    private modalCtrl: ModalController){
      RmtSnackbarComponent.config = this.config;
      RmtSnackbarComponent.modalCtrl = this.modalCtrl;
  }

  ngAfterViewInit() {
    RmtSnackbarComponent.staticContainer = this.container;
    // moving the component from app.html to the ion-app element to be visible
    this.container.nativeElement.parentNode.removeChild(this.container.nativeElement);
    document.getElementsByTagName('ion-app')[0].appendChild(this.container.nativeElement);
  }

  getMessage() {
    return RmtSnackbarComponent.message;
  }

  getIcon() {
    const status = RmtSnackbarComponent.status;
    switch (status) {
      case 'error': return 'custom-icon-error';
      case 'warning': return 'custom-icon-warning';
      case 'info': return 'custom-icon-info';
      case 'success':
      default: return 'custom-icon-checkmark-carbon';
    }
  }
  getStatus() {
    return RmtSnackbarComponent.status;
  }
  getLabel() {
    return RmtSnackbarComponent.label;
  }
  getDuration() {
    return RmtSnackbarComponent.duration;
  }


  swipeDown(event: any): any {
    RmtSnackbarComponent.dismiss();
  }

  static dismiss() {
    RmtSnackbarComponent.isSnackBarPresent = false;
    RmtSnackbarComponent.staticContainer.nativeElement.classList.remove('present');

    clearTimeout(RmtSnackbarComponent.timeout);
    if (RmtSnackbarComponent.queue.length > 0) {
      RmtSnackbarComponent.queue.shift();
      if (RmtSnackbarComponent.queue.length > 0) {
        setTimeout(() => {
          RmtSnackbarComponent.queueConsume();
        }, 500); // should match the css animation time
      }
    }
  }

  static present(message, status = 'success', duration = RmtSnackbarComponent.duration, buttonLabel = '') {
    const snackBar = {
      message: message,
      status: status,
      label: buttonLabel,
      duration: duration
    };
    const isDuplicate = RmtSnackbarComponent.queue.find(({ message }) => message == snackBar.message);
    if (!isDuplicate) {
      RmtSnackbarComponent.queue.push(snackBar);
    }

    RmtSnackbarComponent.queueConsume();
  }

  private static queueConsume() {
    if(!RmtSnackbarComponent.isSnackBarPresent) {
      RmtSnackbarComponent.message = RmtSnackbarComponent.queue[0].message;
      RmtSnackbarComponent.status = RmtSnackbarComponent.queue[0].status;
      RmtSnackbarComponent.label = RmtSnackbarComponent.queue[0].buttonLabel;
      RmtSnackbarComponent.show();
      
      if (RmtSnackbarComponent.queue[0].duration > 0) {
        RmtSnackbarComponent.timeout = setTimeout(async () => {
          RmtSnackbarComponent.dismiss();
        }, RmtSnackbarComponent.queue[0].duration);
      }
    }
  }

  private static show() {
    RmtSnackbarComponent.isSnackBarPresent = true;
    RmtSnackbarComponent.staticContainer.nativeElement.classList.add('present');
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-snackbar/rmt-snackbar.ts